import React, { useEffect, useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { galleryFilters, makpezaFiltersByDomain } from "../../../../utils/entitiesFiltersUtils";
import { selectEntitiesByFilters } from "../../../../store/views/entityView";
import { addOrUpdateUserBoardAccess } from "../../../../store/redux/entities-action";
import { objectToNullNmmDomain } from "../../../../../student/utils/utils";
import CoursesAndAssessmnetsDomainWidget from "./coursesAndAssessmnetsDomainWidget/CoursesAndAssessmnetsDomainWidget";
import useMyLearningDomains from "../useMyLearningDomains";
import CourseGallery from "../../../features/courseGallery/CourseGallery";
// import BagroupAndMakpezeBanners from "../../../features/bagroupAndMakpezeBanners/BagroupAndMakpezeBanners";
import MyLearningDomainHeader from "./myLearningDomainHeader/MyLearningDomainHeader";
import UseFullToolByDomain from "../../usefulToolsPage/useFullToolByDomain/UseFullToolByDomain";
import MessagesDomainWidget from "./messagesDomainWidget/MessagesDomainWidget";
import Page from "../../../ui/page/Page";
import pathRouts from "../../../../enums/pathRoute";
import classes from "./MyLearningDomainPage.module.css";
import boardType from "../../../../enums/boardType";

const MyLearningDomainPage = () => {

    const { domainName, nmmId } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
        if (nmmId)
            dispatch(addOrUpdateUserBoardAccess(`${boardType.messagesByNmm}_${nmmId}`));
    }, [nmmId, dispatch]);
    
    const { texts } = useSelector(state => state.translate);
    const lang = useSelector(state => state.translate.lang);
    const myDomains = useMyLearningDomains();
    const domain = useMemo(() => myDomains?.find(d => d.name === domainName) || objectToNullNmmDomain(domainName), [myDomains, domainName]);
    const makpezaFilter = useMemo(() => makpezaFiltersByDomain(domainName, lang), [domainName, lang]);
    const galleryFilter = useMemo(() => galleryFilters(domainName, lang), [domainName, lang]);
    const galleryCourses = useSelector(state => selectEntitiesByFilters(state, galleryFilter));
    const makpezaCourses = useSelector(state => selectEntitiesByFilters(state, makpezaFilter))
    
    return (
        <Page
            image={domain?.cardDomainImg || domain?.matriculation?.cardDomainImg}
            onBack={() => navigate(`/${pathRouts.MYLEARNING}`)}
            headerEndContent={<MyLearningDomainHeader domain={domain} nmmId={nmmId} />}
            className={classes.MyLearningDomainPage}
        >
            <div className={classes.MyLearningDomainPage}>
                <div className={classes.Content}>
                    <div className={classes.TopPart}>
                        <MessagesDomainWidget studyGroupIds={(domain?.nmmIds ? [...domain?.nmmIds, nmmId] : [nmmId])} />
                        <CoursesAndAssessmnetsDomainWidget domainName={domainName} nmmId={nmmId} nmmIds={domain?.nmmIds} />
                        <div className={classes.TopLeftPart}>
                            {/* <BagroupAndMakpezeBanners domainName={domainName} /> */}
                            <UseFullToolByDomain studyGroupIds={domain?.nmmIds ? [...domain.nmmIds, nmmId] : [nmmId]} />
                        </div>
                    </div>

                    <div className={classes.BottomPart}>
                        <div className={classes.Gallerys}>
                            {makpezaCourses?.length > 0 &&
                                <div className={classes.Gallery}>
                                    <CourseGallery
                                        courses={makpezaCourses}
                                        title={texts.makpeza}
                                    />
                                </div>
                            }
                            {galleryCourses?.length > 0 &&
                                <div className={classes.Gallery}>
                                    <CourseGallery
                                        courses={galleryCourses}
                                        title={texts.coursesByStudyPlan}
                                    />
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </Page>
    );
};

export default MyLearningDomainPage;